// ============================================
// 2026-10-17（M2 权益）：Pro 功能门禁（体积元素 / 商用标绘=箭头族）
//  - 判定依据：GET /auth/quota 的 watermark（false=付费/超管去水印；true=免费档带水印）
//  - 失败放行（软门禁：查询失败不阻塞使用，仅记录日志）
//  - 拦截时复用套餐订阅弹窗（PopupHost → UpgradePopup，testid: upgrade-popup）
// ============================================
import client from '../api/client';
import { usePopupStore } from '../stores/popupStore';
import { isArrowKind } from './annotations/primitives';

let cache: { paid: boolean } | null = null;
let inflight: Promise<{ paid: boolean } | null> | null = null;

/** 清空缓存（测试/登出/切换账号） */
export function resetEntitlementCache(): void {
  cache = null;
  inflight = null;
}

export async function fetchEntitlement(): Promise<{ paid: boolean } | null> {
  if (cache) return cache;
  if (!inflight) {
    inflight = client
      .get('/auth/quota')
      .then((r) => {
        const d = (r.data ?? {}) as { watermark?: boolean; packageCode?: string };
        const code = String(d.packageCode ?? '').toLowerCase();
        const paid = d.watermark === false || (!!code && code !== 'free' && code !== 'basic');
        cache = { paid };
        return cache;
      })
      .catch(() => null)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

/** 商用标绘 = 箭头族（基础标绘点/线/面/矩形/圆/文字 + 椭圆/扇形/自由线/曲线 免费） */
export function isCommercialAnnotationKind(kind: string | null | undefined): boolean {
  return !!kind && isArrowKind(kind);
}

/** 需要 Pro 的功能点：volume=新增体积元素 / annotation=商用标绘（箭头族）。返回 true=放行 */
export async function ensurePaidFeature(feature: 'volume' | 'annotation' | 'chart3d'): Promise<boolean> {
  const ent = await fetchEntitlement();
  if (!ent || ent.paid) return true;
  try {
    usePopupStore.getState().openUpgrade();
  } catch {
    /* 弹窗宿主不可用时静默（仍拦截） */
  }
  return false;
}
